import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import SupplierVerification from './SupplierVerification';
import AssurancePipeline from './AssurancePipeline';
import SupplierTrust from './SupplierTrust';

const TABS = [
  ['verification', 'Verify suppliers', SupplierVerification],
  ['assurance', 'Care City assurance', AssurancePipeline],
  ['trust', 'Trust badges', SupplierTrust],
];

export default function VerificationAssurance() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.some(([k]) => k === sp.get('tab')) ? sp.get('tab') : 'verification';
  return (
    <div data-testid="verification-assurance-page">
      <h1 className="font-heading text-2xl font-extrabold text-gray-900 px-6 pt-6">Verification &amp; Assurance</h1>
      <p className="text-sm text-gray-500 px-6 mb-3">Check supplier details, manage Care City assurance and the trust badges shown on listings.</p>
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v })}>
        <TabsList className="mx-6" data-testid="va-tabs">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`va-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , Comp]) => <TabsContent key={k} value={k}><Comp /></TabsContent>)}
      </Tabs>
    </div>
  );
}
